<template>
  <b-modal
    v-model="modalVisible"
    centered
    size="md"
    modal-class="share-duplicate-notice-modal"
    header-bg-variant="light"
    header-class="share-duplicate-notice-modal-header border-bottom-0"
    body-class="share-duplicate-notice-modal-body pt-0"
    hide-header-close
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <template #modal-title>
      <span class="d-flex align-items-center">
        <b-icon
          icon="info-circle-fill"
          variant="primary"
          font-scale="1.05"
          class="mr-2 flex-shrink-0"
        />
        <span class="share-duplicate-notice-title">Already shared</span>
      </span>
    </template>

    <p
      v-if="subtitle"
      class="text-muted small mb-3 share-duplicate-notice-subtitle"
    >
      {{ subtitle }}
    </p>

    <p class="share-duplicate-notice-lead text-muted mb-3">
      {{ leadCopy }}
    </p>

    <div
      class="share-duplicate-notice-stack rounded overflow-hidden border shadow-sm"
    >
      <div
        v-for="name in projectNames"
        :key="'dup-' + name"
        class="share-duplicate-notice-row d-flex align-items-center"
      >
        <span
          class="share-duplicate-notice-row-accent bg-primary"
          aria-hidden="true"
        />
        <span
          class="share-duplicate-notice-row-label font-weight-medium text-dark"
          >{{ name }}</span
        >
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="primary" @click="close">OK</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ShareProjectDuplicateModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectNames: {
      type: Array,
      default() {
        return []
      },
    },
    subtitle: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      modalVisible: false,
    }
  },

  computed: {
    leadCopy() {
      const n = (this.projectNames && this.projectNames.length) || 0
      if (n === 1) {
        return 'This project has already been shared with this recipient:'
      }
      return 'These projects have already been shared with this recipient:'
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.modalVisible = Boolean(val)
      },
    },
  },

  methods: {
    close() {
      this.modalVisible = false
    },
    onHidden() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.share-duplicate-notice-title {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #212529;
}

.share-duplicate-notice-subtitle {
  line-height: 1.45;
}

.share-duplicate-notice-lead {
  font-size: 0.9375rem;
  line-height: 1.55;
}

.share-duplicate-notice-stack {
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.share-duplicate-notice-row {
  padding: 0.65rem 0.85rem 0.65rem 0;
  background: linear-gradient(180deg, #fafbfc 0%, #f6f8fa 100%);

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}

.share-duplicate-notice-row-accent {
  width: 3px;
  min-height: 1.35rem;
  align-self: stretch;
  border-radius: 0 2px 2px 0;
  margin-right: 0.85rem;
  flex-shrink: 0;
}

.share-duplicate-notice-row-label {
  font-size: 0.95rem;
  letter-spacing: -0.01em;
}
</style>

<style lang="scss">
.share-duplicate-notice-modal {
  z-index: 2060 !important;

  .modal-content {
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.06),
      0 0.75rem 1.75rem rgba(0, 0, 0, 0.1);
  }

  .modal-header {
    padding-bottom: 0.35rem;
  }
}

.share-duplicate-notice-modal-header {
  padding-top: 1.15rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.share-duplicate-notice-modal-body {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
  padding-bottom: 1rem !important;
}

.modal-backdrop + .modal-backdrop {
  z-index: 2055 !important;
}
</style>
